import { put, call, takeLatest } from 'redux-saga/effects'
import {
  REQUEST_CATALOG_DATA,
  REQUEST_HOT_SALE_DATA,
  REQUEST_HOME_PRODUCTS_DATA,
  REQUEST_PRODUCT_LIST_DATA,
  REQUEST_PRODUCT_DETAILS_DATA,
  REQUEST_CART_DATA,
  PUT_CART_ITEM,
  POST_CART_ITEM,
  DELETE_CART_ITEM,
  REQUEST_MALL_ORDER_LIST_DATA,
  FETCH_MALL_BANNER_DATA
} from '../constants/mallConstant'
import {
  fetchBannerSuccess,
  setCatalogState,
  setCatalogData,
  setHotSaleState,
  setHotSaleData,
  setHomeProductsState,
  setHomeProductsData,
  setProductListState,
  setProductListData,
  setProductDetailsState,
  setProductDetailsData,
  setCartData,
  setCartState,
  // setOrderConfirmCoupon,
  setOrderListData
  // setOrderListState
} from '../actions/mallAction'
import { setErrorMessage, setLoadingState } from '../actions/commonAction'
import { handleResponse } from '../utils'

function * fetchBannerData () {
  let request = () => {
    let config = {
      method: 'get',
      url: window.API.Mall.getBanner
    }
    return window.axios(config).then(handleResponse())
  }
  try {
    let data = yield call(request)
    yield put(fetchBannerSuccess(data))
  } catch (error) {
    console.log(error)
  }
}

// 分类
function * requestCatalogsData () {
  yield put(setCatalogState({ loading: true }))
  let request = () => window.axios.request({
    url: window.API.Mall.getCategories,
    params: { pageIndex: 0, pageSize: 0 }
  })
  try {
    let data = yield call(request)
    yield put(setCatalogData(data))
  } catch (error) {
    yield put(setCatalogState({ loading: false, errorMessage: error.message }))
  }
}

// 热销
function * requestHotSaleData () {
  yield put(setHotSaleState({ loading: true }))
  let requestLabels = () => {
    let config = {
      url: window.API.Mall.getLabels,
      params: { pageIndex: 0, pageSize: 0 }
    }
    return window.axios.request(config)
  }
  let requestHotSale = (labelId) => {
    let config = {
      url: window.API.Mall.getProducts,
      params: { pageIndex: 0, pageSize: 20, close: 1, labelId }
    }
    return window.axios.request(config)
  }
  try {
    let labelData = (yield call(requestLabels)).list
    if (labelData) {
      // 查找出热销标签的ID
      let label = labelData.find(item => item['name'] === '热销')
      if (label) {
        let data = yield call(requestHotSale.bind(this, label['id']))
        yield put(setHotSaleData(data))
      } else {
        yield put(setHotSaleState({ loading: false, errorMessage: 'label is null.' }))
      }
    } else {
      yield put(setHotSaleState({ loading: false, errorMessage: 'labelData is null.' }))
    }
  } catch (error) {
    yield put(setHotSaleState({ loading: false, errorMessage: error.message }))
  }
}

// 首页商品列表
function * requestHomeProductsData (action) {
  let { pageIndex = 1 } = action.payload
  yield put(setHomeProductsState({ loading: true }))
  let request = () => {
    let config = {
      url: window.API.Mall.getProducts,
      params: { close: 1, pageSize: 12, pageIndex }
    }
    return window.axios.request(config)
  }
  try {
    let data = yield call(request)
    yield put(setHomeProductsData(data))
  } catch (error) {
    yield put(setHomeProductsState({ loading: false, errorMessage: error.message }))
  }
}

// 获取分类/全部商品列表
function * requestProductListData (action) {
  let { pageIndex, index, keyword } = action.payload
  yield put(setProductListState({ loading: true }))
  let request = () => {
    let params = { close: 1, pageSize: 6, pageIndex }
    if (index === 'search') {
      Object.assign(params, { keyword })
    } else if (index !== 'all') {
      Object.assign(params, { catalogId: index })
    }
    let config = {
      url: window.API.Mall.getProducts,
      params
    }
    return window.axios.request(config)
  }
  try {
    let data = yield call(request)
    yield put(setProductListData({ data, index, keyword }))
  } catch (error) {
    yield put(setProductListState({ loading: false, errorMessage: error.message }))
  }
}

// 获取商品详情
function * requestProductDetailsData (action) {
  let { id } = action.payload
  yield put(setProductDetailsState({ loading: true }))
  let request = () => {
    let config = { url: window.API.Mall.getProductDetails(id) }
    return window.axios.request(config)
  }
  try {
    let data = yield call(request)
    yield put(setProductDetailsData(data))
  } catch (error) {
    yield put(setProductDetailsState({ loading: false, errorMessage: error.message }))
  }
}

// 购物车相关
function * requestCartData () {
  yield put(setCartState({ loading: true }))
  let request = () => {
    let config = { url: window.API.Mall.getCartData }
    return window.axios.request(config)
  }
  try {
    let data = yield call(request)
    yield put(setCartData(data))
  } catch (error) {
    yield put(setCartState({ loading: false, errorMessage: error.message }))
  }
}

// 修改购物车
function * putCartItem (action) {
  const { id, index, amount, checked } = action.payload
  let request = () => {
    let config = {
      method: 'put',
      url: window.API.Mall.putCartItem,
      data: {
        id: index,
        productId: id,
        productCount: amount,
        state: checked ? '1' : '0'
      }
    }
    return window.axios.request(config)
  }
  try {
    yield call(request)
    // yield call(requestCartData)
  } catch (error) {
    yield put(setCartState({ loading: false, errorMessage: error.message }))
  }
}

// 添加购物车
function * postCartItem (action) {
  const { amount, id } = action.payload
  let request = () => {
    const config = {
      method: 'post',
      url: window.API.Mall.postCartItem,
      data: {
        productId: id,
        productCount: amount
      }
    }
    return window.axios(config).then(handleResponse())
  }
  try {
    yield call(request)
    yield call(requestCartData)
  } catch (error) {
    yield put(setCartState({ loading: false, errorMessage: error.message }))
  }
}

function * deleteCartItem (action) {
  const { index } = action.payload
  let request = () => {
    let config = { method: 'delete', url: window.API.Mall.deleteCartItem(index) }
    return window.axios.request(config)
  }
  try {
    yield call(request)
    // yield call(requestCartData)
  } catch (error) {
    yield put(setCartState({ loading: false, errorMessage: error.message }))
  }
}

// 订单列表/详情
function * requestOrderListData () {
  yield put(setLoadingState({ loading: true }))
  let request = () => {
    let config = { url: window.API.Mall.getOrder }
    return window.axios.request(config)
  }
  try {
    let data = yield call(request)
    yield put(setLoadingState({ loading: false }))
    yield put(setOrderListData(data))
  } catch (error) {
    yield put(setErrorMessage(error.message))
  }
}

export function mallSaga () {
  return [
    takeLatest(FETCH_MALL_BANNER_DATA, fetchBannerData),
    // 分类
    takeLatest(REQUEST_CATALOG_DATA, requestCatalogsData),
    // 热销
    takeLatest(REQUEST_HOT_SALE_DATA, requestHotSaleData),
    // 首页列表
    takeLatest(REQUEST_HOME_PRODUCTS_DATA, requestHomeProductsData),
    // 分类/全部商品 列表
    takeLatest(REQUEST_PRODUCT_LIST_DATA, requestProductListData),
    // 商品详情
    takeLatest(REQUEST_PRODUCT_DETAILS_DATA, requestProductDetailsData),
    // 购物车相关
    takeLatest(REQUEST_CART_DATA, requestCartData),
    takeLatest(POST_CART_ITEM, postCartItem),
    takeLatest(PUT_CART_ITEM, putCartItem),
    takeLatest(DELETE_CART_ITEM, deleteCartItem),
    // 订单相关
    takeLatest(REQUEST_MALL_ORDER_LIST_DATA, requestOrderListData)
  ]
}
